import { createBrowserHistory, type History } from 'history';

let preservedHistory: History | null = null;
export const getHistory = (): History<unknown> => {
	if (!preservedHistory) {
		preservedHistory = createBrowserHistory();
	}
	return preservedHistory;
};
